// packages/api/src/query-client.ts

import { QueryClient } from '@tanstack/react-query';

/**
 * Pre-configured QueryClient for all Alamo portals.
 *
 * Defaults:
 * - staleTime: 5 minutes
 * - gcTime: 30 minutes
 * - retry: 1
 * - refetchOnWindowFocus: false
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 30 * 60 * 1000, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
